import { memo } from 'react';
import {
  IconValidationInvalid,
  TextInput,
  type TextInputProps,
} from '@adc/parallax-component-library';

type InputProps = Omit<Exclude<TextInputProps, { multiline: true }>, 'aria-label'> & {
  isInvalid?: boolean;
  errorMessage?: string;
};

const Input = memo<InputProps>(
  ({
    isInvalid = false,
    label = '',
    errorMessage,
    placeholder = '',
    value,
    onBlur,
    onChangeText,
    disabled,
    testID,
    inputMode,
    onFocus,
    ...props
  }) => {
    const showsErrorMessage = isInvalid && errorMessage;

    return (
      <TextInput
        inputMode={inputMode}
        aria-label={label}
        label={label}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        error={isInvalid}
        supportingText={showsErrorMessage ? errorMessage : undefined}
        supportingIconConfig={
          showsErrorMessage
            ? {
                icon: <IconValidationInvalid testID={`${testID}-icon`} />,
                color: '$support.danger.surfaceOnColorAlt',
              }
            : undefined
        }
        onChangeText={onChangeText}
        value={value}
        testID={testID}
        disabled={disabled}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

export { Input };
